export const MESSAGE_COMMON = {
  NOT_EMPTY: '入力必須項目です。ご入力ください。',
  UNKNOWN: '不明なエラー',
  SUCCESS: '成功',
  FAILURE: '失敗',
};

export const MESSAGE_REGISTER = {
  EMAIL_INVALID_FORMAT: 'フォーマットは正しくありません。半角英数字で入力してください。',
  PASSWORD_INVALID_TEXT: 'フォーマットは正しくありません。',
  PASSWORD_INVALID_REQUIRED_TEXT: 'パスワードは次の条件を満たしてください。',
  PASSWORD_MATCHING: 'パスワードが一致しません。ご確認ください。',
  GOVERNMENT_INCORRECT: '所属自治体が正しくありません。',
  EMAIL_INVALID: 'メールアドレスが正しくありません。再度ご確認ください。',
  INVALID_EMAIL: '無効なメールアドレスです。ご確認ください。',
};

export const MESSAGE_CREATE_SURVEY = {
  SAVE_DRAFT: '下書きが保存されました',
  SAVE_PUBLIC: '公開されました',
  SECTION_TITLE: '{section_total} セクション中 {section} 個目のセクション',
  SURVEY_SELECT_EMPTY: '必須項目です。選択してください。',
  START_TIME_BEFORE_END_TIME: '開始日時は、終了日時より前の日付・時刻を選択してください。',
};

export const MESSAGE_FORGOT_PASSWORD = {
  SEND_MAIL_SUCCESS: 'リセットURLが送信されました',
  UPDATE_NEW_PASSWORD_SUCCESS: '新しいパスワードに更新されました',
  PASSWORD_INVALID_TEXT: MESSAGE_REGISTER.PASSWORD_INVALID_TEXT,
  PASSWORD_INVALID_REQUIRED_TEXT: MESSAGE_REGISTER.PASSWORD_INVALID_REQUIRED_TEXT,
  PASSWORD_MATCHING: MESSAGE_REGISTER.PASSWORD_MATCHING,
  INVALID_EMAIL: 'メールアドレスが正しくありません。再度ご確認ください。',
  EMAIL_INVALID_FORMAT: 'フォーマットは正しくありません。半角英数字で入力してください。',
};

export const MESSAGE_PROFILE = {
  UPDATED: '更新されました。',
  PASSWORD_INVALID_TEXT: MESSAGE_REGISTER.PASSWORD_INVALID_TEXT,
  PASSWORD_INVALID_REQUIRED_TEXT: MESSAGE_REGISTER.PASSWORD_INVALID_REQUIRED_TEXT,
  GOVERNMENT_INCORRECT: MESSAGE_REGISTER.GOVERNMENT_INCORRECT,
  PASSWORD_MATCHING: MESSAGE_REGISTER.PASSWORD_MATCHING,
  EMAIL_INVALID: MESSAGE_REGISTER.EMAIL_INVALID,
};

export const MESSAGE_LOGIN = {
  INVALID_EMAIL: 'メールアドレスが正しくありません。再度ご確認ください。',
  EMAIL_INVALID_FORMAT: 'フォーマットは正しくありません。半角英数字で入力してください。',
};

export const MESSAGE_VIEW_SDQ = {
  TITLE_SDQ: 'アンケート パートA',
  TITLE_YABUNAKA: 'アンケート パートB',
  TITLE_MCHAT_DIPOLE: 'アンケート パートC',
  TITLE_PARENTING_SCALE: 'アンケート パートD',
  TITLE_CURIOSITY: 'アンケート パートE',
  TITLE_SAFETY_ASSESSMENT: 'アンケート パートF',
};

export const MESSAGE_VIEW_SDQ_VIETNAM = {
  TITLE_SDQ: 'Khảo sát phần A',
  TITLE_YABUNAKA: 'Khảo sát phần B',
  TITLE_MCHAT_DIPOLE: 'Khảo sát phần C',
  TITLE_PARENTING_SCALE: 'Khảo sát phần D',
  TITLE_CURIOSITY: 'Khảo sát phần E',
  TITLE_SAFETY_ASSESSMENT: 'Khảo sát phần F',
};

export const MESSAGE_TYPE_QUESTION = {
  DESCRIPTIVE_SHORT_ESSAY: '記述式（短文）',
  PARAGRAPH: '段落',
  RADIO: 'ラジオボタン',
  CHECKBOX: 'チェックボックス',
  DROPDOWN: 'プルダウン',
  DATE: '日付',
};

export const MESSAGE_CONTROL_IMAGE = {
  ALIGN_LEFT: '左揃え',
  ALIGN_CENTER: '中央揃え',
  ALIGN_RIGHT: '右揃え',
  DELETE: '削除',
};

export const MESSAGE_CONTROL_QUESTION_COMMON = {
  EXPLANATION: '説明',
};

export const MESSAGE_CONTROL_QUESTION_DATE = {
  INCLUDE_YEAR: '年を含める',
};

export const MESSAGE_SURVEY_AGE = {
  TWO_WEEKS_OLD: '2 週間児健診',
  ONE_MONTH_OLD: '1 か月児健診',
  TWO_MONTHS_OLD: '2 か月児健診',
  FIVE_MONTHS_OLD: '5 か月児健診',
  SIX_SEVEN_MONTHS_OLD: '6～7 か月児健診',
  EIGHT_MONTHS_OLD: '8 か月児健診',
  NINE_TEN_MONTHS_OLD: '9～10 か月児健診',
  ELEVEN_MONTHS_OLD: '11 か月児健診',
  ONE_YEAR_OLD: '1 歳児健診',
  ONE_YEAR_SIX_MONTHS_OLD: '1 歳 6 か月児健診',
  TWO_YEARS_OLD: '2 歳児健診',
  THREE_YEAR_OLD: '3 歳児健診',
  FOUR_YEARS_OLD: '4 歳児健診',
  FIVE_YEARS_OLD: '5 歳児健診',
  SIX_YEARS_OLD: '6 歳児健診',
  TWO_TO_FOUR_YEARS_OLD: '2～4 歳',
  FOUR_TO_SEVENTEEN_YEARS_OLD: '4～17 歳',
};

export const MESSAGE_SURVEY_TYPE = {
  EXAM: '健診問診票',
  SDQ: 'SDQ',
  MCHAT: 'M-CHAT',
  DIPOLE: 'DIPOLE',
  YABUNAKA: 'やぶなか式',
  KINDL: 'KINDL',
  PARENTING_SCALE: '日本版Parenting Scale',
  CURIOSITY: '好奇心',
  SAFETY_ASSESSMENT: '安全性評価',
};

export const MESSAGE_MOTOR_SKILLS = {
  COORDINATED_GROSS_MOTOR_SKILLS: '協調的な粗大運動',
  COORDINATED_FINE_MOTOR_SKILLS: '協調的な巧緻運動',
  MOTOR_PLANNING: '運動企画',
  BASIC_MOTOR_CAPACITY: '基本的な運動能力',
  GROSS: '粗大',
  FINE: '微細',
  SURROUNDING_ENVIRONMENT_PERCEPTION: '周囲の環境把握',
  EYE_MOVEMENT: '眼球運動',
  VISUAL_PERCEPTION: '視覚性認知',
  TOUCH: '触覚',
  PROPRIOCEPTION: '固有感覚',
  VESTIBULAR_SENSATION: '前庭感覚',
  SEPARATIVE_MOVEMENT: '分離運動',
  COORDINATED_MOVEMENT: '協調運動',
  RANGE_OF_MOVEMENT: '関節可動域',
  MUSCLE_ENDURANCE: '筋力',
  BALANCE: 'バランス反応',
};
